import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { genericStyles, Button, Icon } from '@buderus-apps/components'

import styles from './styles.module.scss'

const { h5 } = genericStyles
const {
  header,
  'header__headline': headline,
  'header__new-chat-btn': newChatBtn,
} = styles

type TProps = {
  handleToggleOverlay?: () => void
  onNewChat: () => void
}

const Header: FC<TProps> = (props) => {
  const { handleToggleOverlay = () => null, onNewChat } = props
  const { t } = useTranslation()

  return (
    <div className={header}>
      <h5 className={`${h5} ${headline}`}>
        <span>{t('AI_ASSISTENT')}</span>
      </h5>
      <Button
        icon={<Icon.Edit/>}
        btnStyle={'outlined'}
        onClick={onNewChat}
        className={newChatBtn}
      >
        {t('NEW_CHAT')}
      </Button>
      <Button
        btnStyle={'icon-only'}
        icon={<Icon.Close/>}
        onClick={handleToggleOverlay}
      />
    </div>
  )
}

export default React.memo(Header)
